import Api from 'libs/api/index';

class QRsApi extends Api {
  constructor() {
    super('promo/qrs/');
  }

  uploadFile(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      'upload_file',
    );
  }
}

export default QRsApi;
